// The week of the retail sales weekly winner list.
//
// The sheet is filled in by hand, so the same week arrives as "1", "WK1", "wk 1" or "Week 1".
// Every form is reduced to the one label the backend stores, and anything that does not resolve to
// a week number is rejected here rather than after the upload. This mirrors RetailSalesWeek on the
// backend; both sides must agree, or a row that passes here would fail there.

const WEEK_PATTERN = /^(?:wk|week)?[\s\-_.]*(\d{1,2})$/i;

export const RETAIL_SALES_MIN_WEEK = 1;
export const RETAIL_SALES_MAX_WEEK = 52;

// Returns the stored label ("WK1"), or an empty string when the value is not a usable week.
export const normaliseWeek = (value) => {
     const match = String(value === null || value === undefined ? "" : value)
          .trim()
          .match(WEEK_PATTERN);

     if (!match) {
          return "";
     }

     const number = Number(match[1]);

     if (
          !number ||
          number < RETAIL_SALES_MIN_WEEK ||
          number > RETAIL_SALES_MAX_WEEK
     ) {
          return "";
     }

     return `WK${number}`;
};

export const WEEK_PROBLEM_MESSAGE = `Week must be a number between ${RETAIL_SALES_MIN_WEEK} and ${RETAIL_SALES_MAX_WEEK}`;
